let APIbase = 'https://site.figmawya.com/api/';
let jwtToken = null;
let userData = null;
let userEmail = null;
let userName = null;
let userDisplayName = null;
let userId = null;
let userNicename = null;
let userAvatar = null;
let userGender = null;
let userBio = null;
let userWebsite = null;
let userLocation = null;
let userPhone = null;
let userSocials = null;
let userInterests = null;
let userSkills = null;
let userExperience = null;
let userEducation = null;
let userProjects = null;
let userAchievements = null;
let userLanguages = null;
let userFollowers = null;
let userFollowing = null;
let userPosts = null;
let userComments = null;
let userLikes = null;
let userBookmarks = null;
let userNotifications = null;
let userMessages = null;
let userGroups = null;
let userEvents = null;
let userFriends = null;
let userConnections = null;
let userSubscriptions = null;
let userSettings = null;
let userPrivacy = null;
let userSecurity = null;
let userNotificationsSettings = null;
let userEmailVerified = null;
let userPhoneVerified = null;

// export async function updateUserPassword(userId, newPassword) {
//    console.log('updatting pass');
   
//     const res = await fetch(APIbase + "wp/v2/users/" + userId, {
//         method: "POST",
//         headers: { 
//             "Content-Type": "application/json",
//             ...getAuthHeaders()
//         },
//         body: JSON.stringify({ password: newPassword }),
//     });

//     const data = await res.json();
//     console.log(data);
    
//     if (!res.ok) throw new Error(data.message || "Password update failed");
//     return data;
// }

export async function checkUserExists(email) {
    try {
        const res = await fetch(`${APIbase}wp/v2/users?search=${encodeURIComponent(email)}`, {
            method: 'GET',
            headers: { "Content-Type": "application/json" },
        });

        const users = await res.json();
        
        // Check if any user has this email
        const userExists = users.some(user => user.email === email);
        
        return userExists;
    } catch (error) {
        console.error('Error checking user existence:', error);
        return false; // Assume user doesn't exist if we can't check
    }
}

export async function loginUserGoogleAllInOne(idToken) {
    try {
        // Decode the Google JWT token to get user info
        const userInfo = jwtDecode(idToken);
        const { email, name, given_name, family_name } = userInfo;
        
        // Check if user exists
        const userExists = await checkUserExists(email);
        
        if (userExists) {
            // User exists, try to login with Google social password
            try {
                const loginData = await loginUserGoogle(email);
                return {
                    success: true,
                    linked_with_google: true,
                    message: "تم ربط حساب Google بنجاح",
                    user: loginData
                };
            } catch (loginErr) {
                // User exists but Google login failed
                return {
                    success: false,
                    linked_with_google: false,
                    message: "فشل ربط حساب Google - كلمة المرور غير متوافقة",
                    error: loginErr.message
                };
            }
        } else {
            // User doesn't exist, register them
            try {
                await registerUserGoogle({
                    email,
                    username: email.split("@")[0],
                    password: email + "_google_secret",
                    name: name || given_name,
                    first_name: given_name,
                    last_name: family_name,
                    display_name: name,
                });
                
                // Login after registration
                const loginData = await loginUserGoogle(email);
                return {
                    success: true,
                    linked_with_google: true,
                    message: "تم إنشاء الحساب وربط Google بنجاح",
                    user: loginData
                };
            } catch (regErr) {
                return {
                    success: false,
                    linked_with_google: false,
                    message: "فشل إنشاء الحساب",
                    error: regErr.message
                };
            }
        }
    } catch (err) {
        return {
            success: false,
            linked_with_google: false,
            message: "فشل معالجة بيانات Google",
            error: err.message
        };
    }
}
  

export async function loginUserGoogle(email) {
    const socialPassword = email + "_google_secret";
    
    const res = await fetch(APIbase + "jwt-auth/v1/token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: email, password: socialPassword }),
    });

    const data = await res.json();
    
    if (!res.ok) {
        // Provide more specific error messages for Google login
        if (data.message && data.message.includes("invalid_username")) {
            throw new Error("User not found");
        } else if (data.message && data.message.includes("incorrect_password")) {
            throw new Error("Google account not linked");
        } else {
            throw new Error(data.message || "Google login failed");
        }
    }
    
    return data; // { token, user_email, user_nicename, user_display_name }
}

export async function loginUser(email, password) {
    const res = await fetch(APIbase + "jwt-auth/v1/token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: email, password }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Login failed");
    return data; // { token, user_email, user_nicename, user_display_name }
}

export async function registerUserNormal(data) {
    console.log(JSON.stringify(data));

    const res = await fetch(APIbase + "users/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });

    const response = await res.json();

    console.log(JSON.stringify(response));

    if (!res.ok) {
        throw new Error(response.message || "Registration failed");
    } else {
        console.log("تم التسجيل بنجاح  🎉");
    }

    return data;
}

export async function registerUserGoogle(googleData) {
    console.log(JSON.stringify(googleData));

    const res = await fetch(APIbase + "users/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(googleData),
    });

    const response = await res.json();

    console.log(JSON.stringify(response));

    if (!res.ok) {
        throw new Error(response.message || "Google registration failed");
    } else {
        console.log("تم التسجيل بنجاح عبر Google  🎉");
    }

    return googleData;
}

export default async function registerUser(data) {
    console.log(JSON.stringify(data));

    const res = await fetch(APIbase + "users/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // body: JSON.stringify({ email, username, password }),
        // body: JSON.stringify({ data }),
        body: JSON.stringify(data),
    });

    const response = await res.json();

    console.log(JSON.stringify(response));
    // if (data.code === "rest_user_invalid_email") {
    //     alert("البريد الإلكتروني غير صالح");
    //     return;
    // }

    if (!res.ok) {
        // notify();
        // throw new Error(response);
        throw new Error(response.message || "Registration failed");
        // throw new Error(response.message || "Registration failed");
        // Error(response.message || "Registration failed");
        // console.error(response.message || "Registration failed");
        
     } else {
        console.log("تم التسجيل بنجاح  🎉");
    }

    // if (!res.ok) throw new Error(response.message || "Registration failed") 

    return data;
}